import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { SharedModule } from '@shared/shared.module';
import { FormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { ButtonModule } from '@app/components/button/button.module';
import { PlRadioComponent } from '@app/components/pl-radio/pl-radio.component';
import { IconCustomControlModule } from '@app/components/icon-custom-control/icon-custom-control.module';
import { RadioItemModule } from '@app/components/pl-radio/radioItem/radioItem.module';
import { CheckboxItemModule } from '@app/components/pl-checkbox/checkboxItem/checkboxItem.module';
import { PlSlicePipeModule } from '@shared/pipes/plSlice/plSlice.pipe.module';

@NgModule({
  imports: [
    CommonModule,
    PlIconModule,
    SharedModule,
    FormsModule,
    MatExpansionModule,
    ButtonModule,
    IconCustomControlModule,
    RadioItemModule,
    CheckboxItemModule,
    PlSlicePipeModule,
  ],
  declarations: [PlRadioComponent],
  exports: [PlRadioComponent],
})
export class PlRadioModule {}
